import { has, isNil, isEmpty } from "ramda";
import { User } from "./types";
import { ApplicationState } from "../index";

export function getErrors(user: User | null) {
  return !isNil(user) && has("errors", user) && !isEmpty(user.errors)
    ? user.errors
    : null;
}

export function getById(id: string) {
  return (state: ApplicationState) =>
    state.user?.data?.data?.find((x) => x.id === id);
}
